/**
 * Reddit URL Utilities
 * SESSION_206: Utility functions for handling Reddit URLs
 */

/**
 * Appends ?context=3 to Reddit post/comment URLs to show conversation context.
 * This improves readability by displaying 3 parent comments for context.
 *
 * @param url - The Reddit URL (post permalink or comment link)
 * @returns The URL with ?context=3 appended (or &context=3 if URL already has query params)
 *
 * @example
 * appendRedditContext('https://reddit.com/r/Seattle/comments/abc123/post_title')
 * // Returns: 'https://reddit.com/r/Seattle/comments/abc123/post_title?context=3'
 *
 * appendRedditContext('https://reddit.com/r/Seattle/comments/abc123/post_title?ref=share')
 * // Returns: 'https://reddit.com/r/Seattle/comments/abc123/post_title?ref=share&context=3'
 */
export const appendRedditContext = (url: string | null | undefined): string => {
  if (!url) return '';

  // Don't add context to subreddit URLs (only posts/comments benefit from context)
  if (url.match(/^https?:\/\/(www\.)?reddit\.com\/r\/[^/]+\/?$/)) {
    return url;
  }

  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}context=3`;
};
